/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var _default = function _default() {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    closed = _useState2[0],
    setClosed = _useState2[1];
  (0, _react.useEffect)(function () {
    var timeoutId = setTimeout(function () {
      setClosed(true);
    }, 4000);
    return function () {
      clearTimeout(timeoutId);
    };
  }, []);
  if (closed) {
    return null;
  }
  return _react.default.createElement("div", {
    style: {
      background: '#e16565',
      color: 'black',
      padding: '1.5rem',
      fontSize: '1.25rem',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 100000,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, _react.default.createElement("div", {
    style: {
      flex: 1,
      textAlign: 'center'
    }
  }, "UNLICENSED COPY - FOR EVALUATION USE ONLY"), _react.default.createElement("svg", {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return setClosed(true);
    }
  }, _react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeWidth: "1.33",
    d: "M1 1l8 8m0-8L1 9"
  })));
};
exports.default = _default;